export enum Label {
    Recent = 'Recent',
    Outdated = 'Outdated',
    Offensive = 'Offensive',
    Negative = 'Negative',
    Neologism = 'Neologism',
    Explicit = 'Explicit',
}
